import React from 'react';
import { painPoints } from '../data/landing';
export function PainSection() {
  return <section className="w-full bg-cream py-20 lg:py-24" data-id="element-122" data-mp="38xomh5fo52zr">
      <div className="mx-auto max-w-content px-6" data-id="element-123" data-mp="38x59820yr2s2">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-124" data-mp="2uyx7lgszfdak">
          <div className="lg:sticky lg:top-16 lg:self-start" data-id="element-125" data-mp="2yz7p9qq4zs59">
            <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-126" data-mp="2z1tuhjpk1vkb">
              ¿Sentís que tus clases podrían dar más, pero te falta estructura?
            </h2>
            <p className="mt-6 border-l-2 border-sunset pl-5 text-lg leading-relaxed text-ink-soft" data-id="element-127" data-mp="2q0vqv2j13q29">
              No es falta de ganas, es falta de un sistema.{' '}
              <span className="font-semibold text-ink" data-id="element-128" data-mp="2g9solxed551e">
                El Megapack es la claridad que estabas buscando.
              </span>
            </p>
          </div>

          <ul className="divide-y divide-cream-deep" data-id="element-129" data-mp="278uklf3xcxit">
            {painPoints.map((point, index) => <li key={point} className="flex gap-5 py-5 first:pt-0 last:pb-0" data-id="element-130" data-mp="3rlzhfbze1znc" data-mpi={index}>
                <span className="mt-0.5 font-display text-lg font-bold text-sunset" aria-hidden="true" data-id="element-131" data-mp="3nlyrov6ua20z">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <p className="text-base leading-relaxed text-ink sm:text-lg" data-id="element-132" data-mp="i0z3v7ynda4">
                  {point}
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}